<script lang="ts" setup>
import CatalogFiltersMobile from '~/layers/catalog/components/CatalogFiltersMobile.vue'
import CatalogSort from '~/layers/catalog/components/CatalogSort.vue'
import CatalogSortAndLayoutSwitch from '~/layers/catalog/components/CatalogSortAndLayoutSwitch.vue'
import { useCatalogDataProvider } from '~/layers/catalog/composables/catalogDataProvider'
import { useCatalogGridStore } from '~/layers/catalog/store/catalogGrid'

defineProps<{
  hideSort?: boolean
  viewMode?: 'snippet' | 'table'
}>()

const emit = defineEmits<{
  'update:viewMode': [value: 'snippet' | 'table']
}>()

const { pluralize } = useNuxtApp().$h

const gridStore = useCatalogGridStore()
const { type } = useCatalogDataProvider()

const text = computed(() => {
  return type.value === 'diamonds'
    ? pluralize(gridStore.navigation.total, [
        'бриллиант',
        'бриллианта',
        'бриллиантов',
      ])
    : pluralize(gridStore.navigation.total, [
        'украшение',
        'украшения',
        'украшений',
      ])
})
</script>

<template>
  <div
    id="catalog"
    class="catalog__top"
  >
    <CatalogFiltersMobile />
    <div class="catalog__top-text catalog_desktop-md">Фильтры</div>
    <CatalogSortAndLayoutSwitch v-if="!hideSort" />
    <div class="catalog__top-text catalog__top-text_center catalog_desktop">
      {{ text }}
    </div>
    <div
      v-if="viewMode"
      class="ml-auto flex flex-col items-end gap-2"
    >
      <CatalogSort v-if="!hideSort" />
      <CatalogViewSwitcher
        :model-value="viewMode"
        @update:model-value="emit('update:viewMode', $event)"
      />
    </div>
    <CatalogSort v-else-if="!hideSort" />
  </div>
</template>
